module.exports = __webpack_public_path__ + "static/media/mobile-service-art.006bba40.jpg";